import { FilterUserType } from "@reactive-resume/dto";
import { unknown } from "zod";
import { create } from "zustand";

type FilterUserState = {
  filterUser: FilterUserType | null | undefined;
  setFilterUser: (filter: FilterUserType) => void;
  replaceFilterUser: (filter: FilterUserType | null) => void;
  resetFilterUser: () => void;
};

export const userFilterUserStore = create<FilterUserState>((set) => ({
  filterUser: null,
  setFilterUser: (Nfilter) =>
    set((state) => ({
      filterUser: {
        ...(state.filterUser || {}),
        ...Nfilter,
      },
    })),

  replaceFilterUser: (Nfilter) =>
    set((state) => ({
      filterUser: {
        ...Nfilter,
      },
    })),

  resetFilterUser: () => set((state) => ({ filterUser: null })),
}));
